<template>
  <div class="icon-plus"></div>
</template>
<script>
export default {
  name:'IconPlus',
  props:{
    color:{
      type:String,
      default:'#000'
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../common/common.scss";
  .icon-plus{
    position: absolute;
    padding: px2percent(48/2,1347);
    width: 0;
    height: 0;
    background-color: #000;
    &:after,
    &:before{
      content: "";
      position: absolute;
      background: inherit;
      top:50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
      background-color: inherit;
    }
    &:after {
      width: px2percent(8,48);
      height: 100%;
    }
    &:before {
      width: 100%;
      height: px2percent(8,48);
    }
  }
</style>
